export default "__VITE_ASSET__BJoKJDSP__"